import type { ThunkAction } from "redux-thunk";
import type { AnyAction } from "~/app/store/types";
import { loadCart } from "~/features/cart/cart/api/cartQuoteCommonApi";
import type { RootState } from "~/app/store";
import {
  ADD_QTY,
  LOAD_CART_NONCART_PAGE,
  LOAD_CART_NONCART_PAGE_START,
} from "~/features/addToCart/redux/cartAmounts/actionTypes";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export function loadCartAmounts(): ThunkResult<void> {
  return async (dispatch, getState) => {
    const data = await loadCart().catch(() => null);
    if (data !== null) {
      dispatch({
        type: LOAD_CART_NONCART_PAGE,
        payload: data,
      });
    }
  };
}

export function startLoadingCartAmountsAction() {
  return {
    type: LOAD_CART_NONCART_PAGE_START,
  } as const;
}

export function addQuantity(productCode: string, packCode: string, amount: number, priceReference: string) {
  return {
    type: ADD_QTY,
    payload: {
      productCode,
      packCode,
      amount,
      priceReference,
    },
  };
}
